'use client';
import React from 'react';
import { useEffect } from 'react';

import { useTranslation } from 'react-i18next';

import * as Sentry from '@sentry/nextjs';
import { useRouter } from '@whelk/hooks/src/useRouter';
import { trackCustomEvent } from '@whelk/utils/src/track';
import { BreakDownIcon } from '@whelk/assets/src/web/new-icons';
export default function GlobalError({ error }: { error: Error & { digest?: string } }) {
  const nav = useRouter();
  const { t } = useTranslation();
  useEffect(() => {
    Sentry.captureException(error);
  }, [error]);

  useEffect(() => {
    trackCustomEvent({
      id: 'page_error',
      pageErrorType: 'global_error',
      reason: JSON.stringify(error),
      url: window.location.href,
    });
  }, []);

  return (
    <div className='flex h-[var(--screen)] w-full flex-col items-center justify-center bg-[#F3F4F5]'>
      <img
        className='mb-1 h-[160px] w-[160px]'
        alt='hailuo-breakDown'
        src='/assets/img/breakDown.png'
      />
      <div className='text-col_text02 mb-[40px] text-[14px]'>{t('text_global_error')}</div>
      <div
        className='flex cursor-pointer flex-row items-center text-[14px] text-[#194132]'
        onClick={() => nav.push('/')}
      >
        <div className='mr-1'>{t('button_global_error_back_home')}</div>
        <BreakDownIcon />
      </div>
    </div>
  );
}
